import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../components/global/modal/withModal';
import PhotoSearchUpsell from './PhotoSearchUpsell';

export const PHOTO_SEARCH_UPSELL_MODAL = 'modal/PHOTO_SEARCH_UPSELL';

const propTypes = {
  onRequestClose: PropTypes.func,
  onClose: PropTypes.func,
  actionProps: PropTypes.shape({
    nextUrl: PropTypes.string,
    dismisible: PropTypes.bool,
    forSelection: PropTypes.bool,
    onSelect: PropTypes.func,
  }),
  onCheckoutSuccess: PropTypes.func,
};

const PhotoSearchUpsellModal = ({
  onRequestClose,
  onClose,
  actionProps,
  ...props
}) => {
  const {
    nextUrl,
    dismissible = true,
    forSelection,
    onSelect,
    onCheckoutSuccess,
  } = actionProps ?? {};
  return (
    <Fragment>
      <PhotoSearchUpsell
        onRequestClose={onRequestClose}
        onClose={onClose}
        nextUrl={nextUrl}
        dismissible={dismissible}
        forSelection={forSelection}
        onSelect={onSelect}
        onCheckoutSuccess={onCheckoutSuccess}
        {...props}
      />
      <div className="mb-3" />
    </Fragment>
  );
};

PhotoSearchUpsellModal.propTypes = propTypes;

export default withModal(PhotoSearchUpsellModal, {
  name: PHOTO_SEARCH_UPSELL_MODAL,
  className: 'photo-search-upsell-modal',
  overlayClassName: 'photo-search-upsell-modal-overlay',
  size: 'lg',
  type: 'full',
  hideHeader: true,
  dismissible: false,
});
